import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../assets/banner/banner_index.png';
const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "product_item"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "product_content"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "desc"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "value"
};
const _hoisted_9 = {
  class: "value"
};
const _hoisted_10 = {
  class: "value"
};
const _hoisted_11 = {
  class: "value"
};
const _hoisted_12 = {
  key: 0,
  href: '/ad/specialorder/query',
  class: "item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  return _openBlock(), _createElementBlock(_Fragment, null, [$data.isWeChatMiniProgram ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "back-home-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleBackHome && $options.handleBackHome(...args))
  }, "← 返回首页")) : _createCommentVNode("", true), _createVNode(_component_van_swipe, {
    autoplay: 3000,
    class: "my-swipe",
    "indicator-color": "white",
    style: {
      "width": "7.2rem",
      "margin": "0.1rem auto",
      "border-radius": "0.15rem"
    }
  }, {
    default: _withCtx(() => [$data.userAuth == null ? (_openBlock(), _createBlock(_component_van_swipe_item, {
      key: 0
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        onClick: _cache[1] || (_cache[1] = $event => $options.openPage(1)),
        src: _imports_0
      })]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.products, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: "product_div",
      key: 'products_' + index,
      href: $options.pageUrl(item)
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
      src: item.imageUrl
    }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.detail), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.commonFlow) + " GB", 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
      class: "name"
    }, "通用流量", -1))]), _cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "sep_v"
    }, null, -1)), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.directFlow) + " GB", 1), _cache[3] || (_cache[3] = _createElementVNode("span", {
      class: "name"
    }, "定向流量", -1))]), _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "sep_v"
    }, null, -1)), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_10, _toDisplayString(item.minutes) + " 分钟", 1), _cache[4] || (_cache[4] = _createElementVNode("span", {
      class: "name"
    }, "语音通话", -1))]), _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "sep_v"
    }, null, -1)), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_11, _toDisplayString(item.monthFee) + " 元", 1), _cache[5] || (_cache[5] = _createElementVNode("span", {
      class: "name"
    }, "月租", -1))])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
      class: "btn_div"
    }, "立即办理", -1))])])], 8, _hoisted_1);
  }), 128)), $data.userAuth == null ? (_openBlock(), _createElementBlock("a", _hoisted_12, _cache[10] || (_cache[10] = [_createElementVNode("section", {
    class: "order_query",
    style: {
      "text-align": "center",
      "width": "80%",
      "margin": "0.15rem auto"
    }
  }, " 订单查询 ", -1)]))) : _createCommentVNode("", true), _cache[11] || (_cache[11] = _createElementVNode("div", {
    style: {
      "height": "1rem"
    }
  }, null, -1))])], 64);
}